module.exports = __webpack_public_path__ + "img/setup_guidline6.c55f9c5d.png";